<template>
  <div class="form" v-if="showForm">
    <header class="bg--secondary d--flex">
      <h2
        class="header__title txt--white mt--1 mb--1 ml--2 mr--2 ml--1"
        v-html="node.name"
      ></h2>
      <div class="header__cta mt--1 mb--1 mr--1">
        <q-button-icon icon="times" title="Close" @click="close" />
      </div>
    </header>
    <div class="scl">
      <div class="pt--2 pl--2 pr--2 pb--2 bg--white txt--black">
        <div class="mb--3" v-if="(node.riskSeverity != UNSELECTED) && (this.showSeverity != 'False')">
          <span class="txt--strong txt--upper txt--sm d--b">Risk Severity</span>
          <q-badge variant="info" v-if="node.riskSeverity == UNSELECTED">
            Unselected
          </q-badge>
          <q-badge variant="success" v-if="node.riskSeverity === LOW">
            Low
          </q-badge>
          <q-badge variant="warning" v-if="node.riskSeverity === MEDIUM">
            Medium
          </q-badge>
          <q-badge variant="error" v-if="node.riskSeverity === HIGH">
            <q-icon icon="flag" />
            &nbsp;High
          </q-badge>
        </div>
        <q-display-label title="Care Setting" :value="getCareSetting()" v-if="node.careSetting != CAREUNSELECTED" />
        <div @click.stop.prevent="handleClick">
        <q-display-label
          v-if="node.shortDescription.length > 4"
          title="Key Information"
          :html="getShortDesc()"
          
        />
        </div>
                
        <div class="mb--3" v-if="node.longDescription.length > 5 && node.nodeFunction == '' || node.nodeFunction == null || node.nodeFunction == undefined">
          <span class="txt--strong txt--upper txt--sm d--b"
            >More Information</span
          >
          <div class="wysiwyg" v-html="node.longDescription" @click.stop.prevent="handleClick"></div>
        </div>
        <div class="mb--3 mt--3" v-if="node.pathwayUrl != ''">
          <a :href="node.pathwayUrl" class="btn">
            <span class="mr--1"><q-icon icon="sitemap"/></span> View Pathway
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NodeMetadata",
  data() {
    return {
      showForm: false,
      name: "",
      pathwayUrl: "",
      shortDescription: "",
      showNameInput: false,
      nodeIndex: 0,
      editContent: false,
      editSettings: false,
      children: [],
      node: null,
      possibleConnections: [],
      START: START,
      ACTIVITY: ACTIVITY,
      END: END,
      UNSELECTED: UNSELECTED,
      LOW: LOW,
      MEDIUM: MEDIUM,
      HIGH: HIGH,
      CAREUNSELECTED: CAREUNSELECTED,
      PRIMARY: PRIMARY,
      SECONDARY: SECONDARY,
      SOCIAL: SOCIAL,
      SHOWINFOBTNDEFAULT: SHOWINFOBTN,
      SHOWINFOBTN: SHOWINFOBTN,
      HIDEINFOBTN: HIDEINFOBTN,
      showConnections: false,
      prevContent: "",
      firstContent: "",
      showSeverity: 'True'
    };
  },
  created() {
    var self = this;
    this.$root.$on("editNode", el => {
      self.editNode(el);
    });
    this.$root.$on("postPossibleConnections", nodes => {
      self.possibleConnections = nodes;
    });
  },
  methods: {
    getCareSetting() {
      var value;
      if (this.node.careSetting == CAREUNSELECTED) {
        value = "Care Unselected";
      } else if (this.node.careSetting == PRIMARY) {
        value = "Primary";
      } else if (this.node.careSetting == SECONDARY) {
        value = "Secondary";
      } else if (this.node.careSetting == SOCIAL) {
        value = "Community";
      }
      return value;
    },
    getShortDesc() {
      //return '<div><a href="http://www.tactuum.com">test external link</a></div>'
       return this.node.shortDescription.length > 0
         ? this.node.shortDescription
         : "";
    },
    getPathwayUrl() {
      var pathway = this.node.pathwayUrl;
      return pathway != undefined ? pathway : "";
    },
    editNode(el) {
      this.showForm = true;
      this.showNameInput = false;
      if (!this.node || this.node.id !== el.id) {
        this.editContent = true;
        this.editSettings = false;
        this.firstContent = el.toObjectString("EDIT");
      }
      this.children = el.children;
      this.node = el;
      this.possibleConnections = [];
      this.showConnections = false;
      this.prevContent = el.toObjectString("EDIT");
      this.showSeverity = document.getElementById('showKeyButton').value;
    },
    close() {
      this.$root.$emit("closePanel");
    },
    getComponentData() {
      return {
        on: {
          end: this.handleMoved
        },
        props: {
          value: this.children
        }
      };
    }
  }
};
</script>